// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import Vant from 'vant'
import 'vant/lib/index.css';
import App from './App'
import router from './router'

import i18n from '@/assets/i18n'
import vConsole from 'vconsole'
Vue.use(Vant)
/*Vue.config.productionTip = false*/
//Vue.prototype.baseUrl = "http://xiangqin.anbig.com"
/*Vue.prototype.baseUrl = "http://yiyu.imifan.vip"*/
/*Vue.prototype.baseUrl = "http://iyuelao.cn"*/
/*Vue.prototype.baseUrl = "http://www.bogo.xiangqin.php"*/
/*Vue.prototype.baseUrl = "http://live.yudui.cn"*/
//Vue.prototype.baseUrlApi = Vue.prototype.baseUrl + "/"
Vue.config.productionTip = false
Vue.prototype.baseUrlApi = process.env.API_ROOT
import { Locale } from 'vant';
// 引入日语语言包
import jaJP from 'vant/es/locale/lang/ja-JP';

Locale.use('ja-JP', jaJP);
/* eslint-disable no-new */

new Vue({
  el: '#app',
  router,
  i18n,
  vConsole,
  components: { App },
  template: '<App/>',
})

// 页面修改时修改浏览器标签栏
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.meta.icon) {
    document.icon = to.meta.icon
  }
  next()
})



// WEBPACK FOOTER //
// ./src/main.js